import React from 'react';
import {Parallax} from 'react-parallax';
import novanautHead from '../../../static/images/novanaut--head.svg';
import NewsletterBody from "./NewsletterBody";
import backgroundImage from '../../../static/images/stars-background.png';


class Newsletter extends React.Component {
    state = {
        email: '',
        errors: [],
        success: false,
    };

    onSubmit = (e) => {
        e.preventDefault();
        const countryCode = DJ_CONST.countryCode;
        if (countryCode && typeof countryCode === 'string') {
            fetch('/api/v1/newsletter_sign_ups/', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({
                    email: this.state.email,
                    country: DJ_CONST.countryCode.toUpperCase(),
                }),
            })
            .then((response) => {
                if (response.status === 201) {
                    this.handleSuccess();
                } else {
                    response.json()
                    .then(value => (
                        this.handleError(value)
                    ))
                    .catch(() => (
                        this.handleError(null)
                    ));
                }
            });
        } else {
            this.handleError('Failed to get country');
        }
    };

    handleEmailChange = (e) => {
        e.preventDefault();
        this.setState({
            email: e.target.value,
            errors: [],
        });
    };

    handleError(error) {
        let errors = [];
        if (typeof error === 'string') {
            errors = [...errors, error];
        }
        if (error && error.email && error.email.length > 0) {
            errors = [...errors, ...error.email];
        }
        if (error && error.non_field_errors && error.non_field_errors.length > 0) {
            errors = [...errors, ...error.non_field_errors];
        }
        if (errors.length < 1) {
            errors = ['Unknown error occured.'];
        }
        this.setState({errors});
    }

    handleSuccess() {
        this.setState({success: true});
    }

    render() {
        return (
            <div className="newsletter">
                <Parallax
                    bgImage={backgroundImage}
                    strength={400}
                >
                    <NewsletterBody
                        success={this.state.success}
                        emailValue={this.state.email}
                        errors={this.state.errors}
                        handleEmailChange={this.handleEmailChange}
                        onSubmit={this.onSubmit}
                    />
                </Parallax>
                <img src={novanautHead} className="novanaut--head" alt="Novanaut head" />
            </div>
        );
    }
}


export default Newsletter;



// WEBPACK FOOTER //
// ./src/components/Newsletter.js